"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerActions = void 0;
class PlayerActions {
    static isWait(a) {
        return a.tag === 'wait';
    }
    static isBeginPlay(a) {
        return a.tag === 'beginplay';
    }
    static isFold(a) {
        return a.tag === 'fold';
    }
    static isGoAllIn(a) {
        return a.tag === 'goallin';
    }
    static isSitOut(a) {
        return a.tag === 'sitout';
    }
    static isOutForever(a) {
        return a.tag === 'outforever';
    }
    static isDisconnect(a) {
        return a.tag === 'disconnect';
    }
    static isObserv(a) {
        return a.tag === 'observ';
    }
}
exports.PlayerActions = PlayerActions;
PlayerActions.Wait = {
    tag: 'wait',
};
PlayerActions.BeginPlay = {
    tag: 'beginplay',
};
PlayerActions.Fold = {
    tag: 'fold',
};
PlayerActions.GoAllIn = {
    tag: 'goallin',
};
PlayerActions.SitOut = {
    tag: 'sitout',
};
PlayerActions.OutForever = {
    tag: 'outforever',
};
PlayerActions.Disconnect = {
    tag: 'disconnect',
};
PlayerActions.Observ = {
    tag: 'observ',
};
//# sourceMappingURL=PlayerStateAction.js.map